<template>
  <OutReach24HourPerformance
    v-if="stats"
    :opens="opens"
    :clicks="clicks"
    :labels="labels"
    :loading="loading"
  />
</template>
<script>
export default {

  name: 'OutReach24HourPerformanceContainer',
  computed: {
    outreachId() {
      return this.$route.params.id;
    },
    stats() {
      return this.$store.state.outreachs.stats;
    },
    opens() {
      if (!this.stats.open_timeline) return [];
      return this.stats.open_timeline.map(this.getValues);
    },
    clicks() {
      if (!this.stats.click_timeline) return [];
      return this.stats.click_timeline.map(this.getValues);
    },
    labels() {
      if (!this.stats.open_timeline) return [];
      return this.stats.open_timeline.map((item) => this.timeToHumanReadable(item[0]));
    },
    loading() {
      return this.$store.state.outreachs.statsLoading;
    },
  },
  methods: {
    getValues(item) {
      return { title: this.stats.edit.subject.striphtml(), value: item[1], time_formatted: item[2] };
    },
    timeToHumanReadable(time) {
      const timeSlot = time < 12 ? 'AM' : 'PM';
      let key = time <= 12 ? time : time - 12;
      if (key === 0) key = 12;
      const padding = key.toString().length === 1 ? '0' : '';

      return `${padding}${key}:00${timeSlot}`;
    },
  },
};
</script>
